import React from 'react'
import pp from "../assets/pp.png"
function Image() {
  return (
    <>
   
    
    <div id="pp"  style={{  "backgroundColor":"#0a192f",    "width":"100%"}}>

              
               <div   style={{"marginLeft":"80px"}}>
                
                <img id="imgbox" src={pp} alt="" />


               </div>

   

    </div>
    
    </>
  )
}

export default Image